
import '../styles/Loading.css';
import diceGif from '../assets/loadinganimations/dice.gif';

const loadingText = 'loading....';

export default function Loading({ active = true, mode, overlay = false }) {
	if (!active) {
		return null;
	}

	return (
		<div className={`loading-wrapper loading-wrapper--${mode}${overlay ? ' loading-wrapper--overlay' : ''}`}>
			<div className="loading-gif" role="presentation">
				<img src={diceGif} alt="Rolling dice animation" />
			</div>
			<div className="loading-text" role="status" aria-live="polite">
				{loadingText.split('').map((letter, index) => (
					<span key={`${letter}-${index}`} style={{ animationDelay: `${index * 0.12}s` }}>
						{letter}
					</span>
				))}
			</div>
		</div>
	);
}